'use client';

/**
 * useTheme.ts — lys/mørk tema
 *
 * - choice: brukerens valg («light» | «dark» | «system»)
 * - theme: gjeldende tema («light» | «dark»)
 * - setChoice: bytter tema (lagres, og settes på <html>)
 * - toggle: bytter mellom lys og mørk (gjør valget eksplisitt)
 *
 * Bygger på lib/theme.ts. Serveren rendrer «light»/«system»; klienten
 * oppdateres etter hydrering (useSyncExternalStore), uten hydreringsfeil.
 */

import { useCallback, useSyncExternalStore } from 'react';
import {
  readThemeChoice,
  resolveTheme,
  setThemeChoice,
  subscribeTheme,
  type ResolvedTheme,
  type ThemeChoice,
} from '@/lib/theme';

export function useTheme() {
  const choice = useSyncExternalStore<ThemeChoice>(subscribeTheme, readThemeChoice, () => 'system');
  const theme = useSyncExternalStore<ResolvedTheme>(
    subscribeTheme,
    () => resolveTheme(readThemeChoice()),
    () => 'light'
  );
  const toggle = useCallback(
    () => setThemeChoice(resolveTheme(readThemeChoice()) === 'dark' ? 'light' : 'dark'),
    []
  );
  return { choice, theme, setChoice: setThemeChoice, toggle };
}
